import axios from 'axios'
import store from '@store'
import { DEFAULT_API_PATH, DEFAULT_API_PATH_DEV, DEFAULT_API_PATH_PROD } from "@src/config/api-path";
import { getLocalStorage } from "@utils/localStorage";
import {messageError} from "@utils/message";
import {Trans} from "@utils/translation";
import router from "@router/index";

const isDevSite = window.globalData.APP_ENV === 'local';
const isSetApiDev = getLocalStorage('set.isApiDev');

// 開發站能夠透過 set.isApiDev 切換 APi Path
if(isDevSite && typeof isSetApiDev === 'boolean') {
  const apiPath = isSetApiDev
    ? DEFAULT_API_PATH_DEV
    : DEFAULT_API_PATH_PROD;

  axios.defaults.baseURL = apiPath;

  window.onload = () => {
    const createMark = () => {
      const mark = document.createElement("div");

      mark.classList.add('dev-mark');
      document.body.appendChild(mark)
    };

    if(apiPath === DEFAULT_API_PATH_DEV) {
      createMark();
    }
  };
}else {
  axios.defaults.baseURL = DEFAULT_API_PATH
}

console.log('API_PATH:', axios.defaults.baseURL);

axios.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

axios.interceptors.response.use((response) => {
  return response.data && (response.data.data || response.data)
}, errorResponseHandler);

function errorResponseHandler(error) {
  // check fro errorHandle config
  const { config, response } = error;

  if (response) {
    if (config.hasOwnProperty('customErrorHandle')) {
      config.customErrorHandle(response.data);

      return Promise.reject(response.data);
    }

    // axios v0.19.0 custom config 會被忽略
    if (config.hasOwnProperty('errorHandle') && config.errorHandle === false) {
      return response.data
    }

    messageError(response.data.message);

    // 405 Method Not Allowed
    if(response.data.code === 405 || response.data.code === 401) {
      store.dispatch('auth/logOut')
        .then(() => {
          router.push({
            name: 'login',
            query: {
              redirectFrom: location.pathname
            },
            params: {
              lang: Trans.getUserSupportedLang()
            }
          })
          // window.location = `/${Trans.getUserSupportedLang()}/login?redirectFrom=${location.pathname}`;
        });
    }

    return Promise.reject(response.data)
  } else if (!window.navigator.onLine) {
    messageError('網路出了點問題，請重新連線後刷新頁面');
  } else {
    return Promise.reject(error)
  }
}

export default axios
